document.addEventListener('DOMContentLoaded', () => {
  const popUpTrigger = document.querySelector('.delivery_info_wrapper');
  const popUp = document.querySelector('.delivery_popup_wrapper');
  const popUpOverlay = document.querySelector('.delivery_popup_overlay');
  const closeMob = document.querySelector('.delivery_popup_close_mob');
  const closeDes = document.querySelector('.delivery_popup_close_des');
  
  const closeElms = [popUpOverlay, closeMob, closeDes];
  
  popUpTrigger.addEventListener('click', () => {
    popUp.classList.add('show');
    popUpOverlay.classList.add('show');
  });
  
  closeElms.forEach(el => {
    el.addEventListener('click', () => {
      popUp.classList.remove('show');
      popUpOverlay.classList.remove('show');
    });
  });

  // Define shipping days per country
  const shippingDays = {
    'US': 2, 'DE': 1, 'AT': 2, 'BE': 1, 'CA': 2, 'NL': 1, 'FR': 2, 'IE': 2, 'KW': 2, 'NO': 1,
    'SA': 2, 'SE': 2, 'CH': 1, 'AE': 2, 'GB': 1, 'BH': 2, 'BG': 5, 'HR': 4, 'CZ': 3, 'DK': 1,
    'EE': 2, 'FI': 2, 'GR': 2, 'HU': 3, 'IL': 2, 'IT': 3, 'LV': 3, 'LI': 2, 'LT': 2, 'LU': 2,
    'MT': 2, 'MC': 2, 'NZ': 2, 'PL': 3, 'PT': 3, 'QA': 2, 'RO': 5, 'SG': 2, 'SK': 2, 'SI': 2,
    'ES': 2, 'UA': 3
  };

  // Determine delivery date
  const now = new Date();
  const country = Shopify.country || 'US'; // Default to US if not available
  const deliveryDays = shippingDays[country] || 3; // Default to 3 days if country not listed

  now.setDate(now.getDate() + deliveryDays);

  const options = { timeZone: 'Europe/Amsterdam' };
  const day = now.toLocaleDateString('en-GB', { day: '2-digit', ...options });
  const month = now.toLocaleDateString('en-GB', { month: 'long', ...options });
  const formattedDate = `${day} ${month}`;

  // Create a span element with the bold date
  const dateSpan = document.createElement('span');
  dateSpan.textContent = formattedDate;

  // Append to the delivery_info_text div
  const deliveryInfoText = document.querySelector('.delivery_info_text');
  if (deliveryInfoText) {
    deliveryInfoText.appendChild(dateSpan);
  }
});